import { useCallback, useState } from 'react'
import axios from 'axios'
import config from 'config'
import { useTranslation } from 'react-i18next'

import useSnackbar from '../Snackbar/useSnackbar'

const useCarsToBuySession = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    isFetching: false,
    isUpdating: false,
    session: {},
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
      isUpdating: false,
    }))
  }, [setState])

  const setStopFetching = useCallback(
    (error) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        error: error,
      }))
    },
    [setState]
  )

  // const setStartUpdating = useCallback(() => {
  //   setState((s) => ({
  //     ...s,
  //     isFetching: false,
  //     isUpdating: true,
  //   }))
  // }, [setState])

  // const setStopUpdating = useCallback(() => {
  //   setState((s) => ({
  //     ...s,
  //     isUpdating: false,
  //   }))
  // }, [setState])

  const setSuccessFetching = useCallback(
    (session) => {
      setState((s) => ({
        ...s,
        session,
        isFetching: false,
        isUpdating: false,
        error: null,
      }))
    },
    [setState]
  )

  const fetchSession = useCallback(
    async (partnerId, previous) => {
      setStartFetching()

      try {
        const results = await axios.get(
          `${config.apiBaseUrl}sessions/current-cars-to-buy/${partnerId}${
            previous ? '/previous' : ''
          }`
        )

        setSuccessFetching(
          results?.data?.body ? { ...results.data.body, partnerId } : {}
        )
      } catch (e) {
        let message = t('common.error.fetchData', {
          attribute: e?.response?.status,
        })

        setStopFetching(e)

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartFetching,
      setStopFetching,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )

  return {
    session: state.session,
    isFetching: state.isFetching,
    isUpdating: state.isUpdating,
    error: state.error,
    fetchSession,
  }
}

export default useCarsToBuySession
